export const createNewPostCommentRequest = (
  linked_in_profile_post_id,
  comment_text,
  auto_like,
  linked_in_account_id,
  list_post_id,
  linked_in_company_page_id,
  attachment = {}
) => {
  const data = {
    linked_in_profile_post_id,
    comment_text,
    linked_in_account_id,
    auto_like,
    list_post_id,
    linked_in_company_page_id,
  };
  if (attachment.media_item_id) data.media_item_id = attachment.media_item_id;
  if (attachment.gif_url) data.gif_url = attachment.gif_url;
  return {
    url: "/comments",
    method: "POST",
    data,
  };
};

export const createLikePostRequest = (
  list_post_id,
  linked_in_account_id,
  linked_in_profile_post_id,
  linked_in_company_page_id,
  reaction_type = "LIKE"
) => {
  return {
    url: "/likes",
    method: "POST",
    data: {
      list_post_id,
      linked_in_account_id,
      linked_in_profile_post_id,
      linked_in_company_page_id,
      reaction_type,
    },
  };
};

export const createRepostRequest = ({
  linked_in_profile_post_id,
  linked_in_account_id,
  list_post_id,
  linked_in_company_page_id = null,
  commentary = "",
}) => {
  const data = {
    linked_in_profile_post_id,
    linked_in_account_id,
    list_post_id,
    linked_in_company_page_id,
  };
  const trimmed = (commentary || "").trim();
  if (trimmed) data.commentary = trimmed;
  return {
    url: "/reposts",
    method: "POST",
    data,
  };
};
